import React, { useMemo } from 'react';
import { FlatList, View } from 'react-native';
import { getChannelUniqId } from '@sendbird/uikit-utils';
import type { GroupChannelListProps } from '@sendbird/uikit-react-native';
import { CHAT_ROW } from '../../constants';
import { getChannelsRenderKey, sortChannelsByLastMessage } from '../../utils/channelPreview';
import { ChatChannelRow } from '../cards/ChatChannelRow';

export const ChatChannelList = ({
    groupChannels,
    onPressChannel,
    onLoadNext,
    flatListProps,
}: GroupChannelListProps['List']) => {
    const channels = useMemo(() => sortChannelsByLastMessage(groupChannels), [groupChannels]);

    return (
        <View className="flex-1 border-t border-gray-300">
            <FlatList
                data={channels}
                extraData={getChannelsRenderKey(channels)}
                keyExtractor={getChannelUniqId}
                onEndReached={onLoadNext}
                getItemLayout={(_, index) => ({ length: CHAT_ROW.height, offset: CHAT_ROW.height * index, index })}
                renderItem={({ item }) => <ChatChannelRow channel={item} onPress={() => onPressChannel(item)} />}
                {...flatListProps}
            />
        </View>
    );
};
